import React from 'react'
import {
  Box,
  Divider,
  Typography
} from '@mui/material'

export const DetailRow = ({ label, value, multiline = false, dense = false }) => {
  return (
    <>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            sm: dense ? '160px 1fr' : '260px 1fr'
          },
          gap: {
            xs: 0.5,
            sm: dense ? 1.5 : 3
          },
          alignItems: multiline ? 'flex-start' : 'center',
          py: dense ? 0.5 : 1.5
        }}
      >
        <Typography
          variant='body2'
          color='text.secondary'
          sx={{
            fontWeight: 600
          }}
        >
          {label}
        </Typography>

        <Typography
          variant='body1'
          sx={{
            textAlign: {
              xs: 'left',
              sm: 'right'
            },
            whiteSpace: multiline ? 'pre-line' : 'normal',
            wordBreak: 'break-word'
          }}
        >
          {value ? value : '-'}
        </Typography>
      </Box>

      <Divider />
    </>
  )
}